import React, {useState, useEffect} from 'react';
import {View} from 'react-native';

import sy from '~/styles';
import {Text, Pressable} from '~/components/controls';

const TabBar = ({tab, children, onChangeTab}) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (index, child) => {
    onChangeTab(child.props?.label ?? index);
  };

  useEffect(() => {
    if (tab && children) {
      const tabIndex = children.findIndex((child) => child.props.label === tab);
      if (tabIndex !== -1) {
        setActiveTab(tabIndex);
      }
    }
  }, [tab, children]);

  return (
    <View
      style={[
        sy['bg-white'],
        sy['flex-row'],
        sy['justify-center'],
        {
          height: 56,
        },
      ]}>
      {React.Children.map(children, (child, index) =>
        React.cloneElement(child, {
          active: index === activeTab,
          onPress: () => handleTabChange(index, child),
        }),
      )}
    </View>
  );
};

TabBar.Tab = ({
  label,
  icon = {
    filled: null,
    outlined: null,
  },
  badge,
  active,
  onPress,
}) => {
  let tabIcon;
  if (active) {
    tabIcon = React.cloneElement(icon.filled, {
      fill: '#2907E3',
    });
  } else {
    tabIcon = React.cloneElement(icon.outlined, {
      fill: '#4a4a49',
    });
  }

  return (
    <Pressable
      style={[
        sy['flex-1'],
        sy['items-center'],
        {
          gap: 2,
          maxWidth: 130,
        },
      ]}
      onPress={onPress}>
      <View style={[{width: 24, height: 24}]}>
        {tabIcon}
        {badge}
      </View>
      <Text
        style={[
          sy.smallRegular,
          sy['mb-1'],
          active ? sy['text-linkblue'] : null,
        ]}>
        {label}
      </Text>
      {active && (
        <View
          style={[
            sy['justify-self-end'],
            {
              borderTopLeftRadius: 100,
              borderTopRightRadius: 100,
              borderTopWidth: 4,
              borderTopColor: '#2907E3',
              width: 20,
            },
          ]}
        />
      )}
    </Pressable>
  );
};

TabBar.Content = ({tab, children}) => {
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    if (tab && children) {
      const tabIndex = children.findIndex((child) => child.props.tab === tab);
      if (tabIndex !== -1) {
        setActiveTab(tabIndex);
      }
    }
  }, [tab, children]);

  return (
    <View style={[sy['flex-1'], {position: 'relative'}]}>
      {React.Children.map(children, (child, index) => (
        <View
          style={[
            sy['flex-1'],
            {
              position: 'absolute',
              height: '100%',
              width: '100%',
              zIndex: activeTab === index ? 1 : 0,
            },
          ]}>
          {React.cloneElement(child, {
            focused: activeTab === index,
          })}
        </View>
      ))}
    </View>
  );
};

export default TabBar;
